module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO29DiferentesTiposDeGastosb.4f1ac9f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO29DiferentesTiposDeGastosb.mp4
// module id = 755
// module chunks = 1